import React from 'react';
import { connect } from 'react-redux';
import { Grid } from './../../../themes/default';
import { Section, Content } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { PollReport, WheelReport, AutogestionReport } from './../block';
import { hasPermission } from './../../../utilities/utils';

function renderItem(children, listOfPermissions, permission) {

  const needCheckPermissions = listOfPermissions && permission;

  return (
    ( (needCheckPermissions && hasPermission(listOfPermissions, permission))) && (
      <React.Fragment>
        { children }
      </React.Fragment>
    )
  );

}

class Dashboard extends React.Component {

  constructor(props){
    super(props);
    this.state = {};
  }

  render(){

    const permissions = this.props.user.user ? this.props.user.user.permissions : null;

    return (
      <Section>
        <ToolbarPrimary title="Dashboard"/>
        <Content>
          <Grid container spacing={24}>

            { renderItem(
                <Grid item lg={4} md={4} sm={12} xs={12}>
                  <PollReport/>
                </Grid>,
                permissions,
                'POLL_ALL'
              )
            }

            { renderItem(
                <Grid item lg={4} md={4} sm={12} xs={12}>
                  <WheelReport/>
                </Grid>,
                permissions,
                'WHEEL_ALL'
              )
            }

            { renderItem(
                <Grid item lg={4} md={4} sm={12} xs={12}>
                  <AutogestionReport/>
                </Grid>,
                permissions,
                'AUTOGESTION_ALL'
              )
            }

          </Grid>
        </Content>
      </Section>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.User
  }
}

export default connect(mapStateToProps)(Dashboard);
